import { useCallback, useMemo } from "react";
import { useApiService } from "./index";
import {
  CreateOperatorRequest,
  Operator,
  UpdateOperatorRequest,
} from "../types/operator";

export const useOperatorService = () => {
  const { get, post, put, delete: remove } = useApiService();

  const getOperators = useCallback(async (activeOnly = false) => {
    const response = await get<Operator[]>(
      `/api/operators?activeOnly=${activeOnly}`
    );
    return response.data;
  }, [get]);

  const createOperator = useCallback(
    async (payload: CreateOperatorRequest) => {
      const response = await post<Operator>("/api/operators", payload);
      return response.data;
    },
    [post]
  );

  const updateOperator = useCallback(
    async (id: string, payload: UpdateOperatorRequest) => {
      const response = await put<Operator>(`/api/operators/${id}`, payload);
      return response.data;
    },
    [put]
  );

  const deactivateOperator = useCallback(
    async (id: string) => {
      await remove(`/api/operators/${id}`);
    },
    [remove]
  );

  const activateOperator = useCallback(
    async (id: string) => {
      await post<boolean>(`/api/operators/${id}/activate`, {});
    },
    [post]
  );

  return useMemo(
    () => ({
      getOperators,
      createOperator,
      updateOperator,
      deactivateOperator,
      activateOperator,
    }),
    [getOperators, createOperator, updateOperator, deactivateOperator, activateOperator]
  );
};
